import Vue from 'vue';
import axios from 'axios';

export async function FetchChildCriterion({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/challenge/`,
  })
    .then((response) => {
      commit('setCriterionList', { data: response.data, childId: childId });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function CreateNewCriterion({ dispatch, commit }, data) {
  try {
    commit('cleanErrors');
    await axios.post('/criterion/', data);
    dispatch('fetchChildCriterionValues', { childId: data.child, date: data.date });
    return true;
  } catch (error) {
    commit('error', error);
    throw new Error('Error when trying create the criterion...');
  }
}

export async function UpdateNewCriterion({ dispatch, commit }, data) {
  let returnValue = false;
  commit('cleanErrors');
  await Vue.axios({
    method: 'PATCH',
    url: `/criterion/${data.id}/`,
    data: data,
  })
    .then(() => {
      return dispatch('fetchChildCriterionValues', { childId: data.child, date: data.date }).then(
        () => (returnValue = true),
      );
    })
    .catch((error) => {
      console.log(error);
      commit('error', error);
    });

  return returnValue;
}

export async function DeleteCriterion(
  { dispatch, commit },
  { criterionId, childId, date, timeDay },
) {
  try {
    await axios({
      url: `/criterion/${criterionId}/`,
      method: 'DELETE',
      data: {
        timeDay,
      },
    });
    dispatch('fetchChildCriterionValues', { childId, date });
  } catch (error) {
    commit('error', error);
    throw new Error(
      'Oops, we had a problem deleting this challenge, try again later or contact support.',
    );
  }
}

export async function AddCriterion({ dispatch, commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'PATCH',
    url: `/criterion/${data.criterionId}/`,
    data: {
      child: data.childId,
      timeDay: data.timeDay,
    },
  })
    .then(() => {
      return dispatch('FetchChildCriterion', data.childId).then((response) =>
        console.log(response),
      );
    })
    .catch((error) => {
      console.log(error);
      commit('error', error);
    });
}

export async function ModifyStarCriteria({ dispatch, commit }, data) {
  console.log(data);
  commit('cleanErrors');
  await Vue.axios({
    method: 'PATCH',
    url: `/criterion/${data.criterionId}/`,
    data: {
      child: data.childId,
      timeDay: data.timeDay,
      starsValue: data.starsValue,
    },
  })
    .then(() => {
      return dispatch('FetchChildCriterion', data.childId).then((response) =>
        console.log(response),
      );
    })
    .catch((error) => {
      console.log(error);
      commit('error', error);
    });
}

/* @TODO: Remove methods when migrate actions to the unique function */
export async function FetchChildCriterionValuesToday({ commit }, childId) {
  commit('cleanErrors');
  try {
    const { data: valuesData } = await axios.get(`/child/${childId}/challenge_values/`);
    const todayChallenges = valuesData[Object.keys(valuesData)[0]];
    commit('setPossibleStarsToday', todayChallenges);
    const { data: orderData } = await axios.get(`/child/${childId}/challenges_order/`);
    commit('setHomeChallengeSkill', valuesData.home_challenge_skill_id);
    delete valuesData['home_challenge_skill_id'];
    commit('addCriterionValues', {
      data: valuesData,
      orderResponse: orderData['challenges_order'],
      childId: childId,
    });
  } catch (error) {
    commit('error', error);
  }
}

export async function FetchChildCriterionValuesByDate({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/child/${data.childId}/challenge_values/?date=${data.date}`,
  })
    .then((response) => {
      commit('addCriterionValues', {
        data: response.data,
        childId: data.childId,
      });
    })
    .catch((error) => {
      commit('error', error);
    });
}
/* end @TODO */

export async function fetchChildCriterionValues({ commit }, { date, childId }) {
  try {
    const { data } = await axios.get(`/child/${childId}/challenge_values/`, { params: { date } });
    const { data: orderData } = await axios.get(`/child/${childId}/challenges_order/`);
    const dateKey = Object.keys(data)[0];
    const challengesBydate = data[dateKey];
    commit('updateStarToChild', { childId, startsEarned: data.total_stars_earned });
    commit('setPossibleStarsToday', challengesBydate);
    commit('setHomeChallengeSkill', data.home_challenge_skill_id);
    commit('setAvilableDays', { availableDates: data.editable_days, childId });
    commit('setEditableDays', { editableDates: data.editable_days });
    commit('setCriterionValues', {
      values: data[dateKey],
      orderResponse: orderData['challenges_order'],
      childId: childId,
      date: dateKey,
    });
  } catch (error) {
    throw new Error('Error when trying fetch the criterion values...');
  }
}

export async function updateChallengeOrderByChild({ commit }, payload) {
  try {
    const { childId, challengesOrderByday } = payload;
    await axios.post(`/child/${childId}/challenges_order/`, {
      challenges_order: {
        child_id: childId,
        time_day_order: challengesOrderByday,
      },
    });
  } catch (error) {
    commit('error', error);
    throw new Error('Ups!, we have a problem when trying sort the challenges');
  }
}

export async function setParentCheckValues(
  { dispatch, commit },
  { items, time_day, date, childId },
) {
  try {
    for (let element of items) {
      await axios.post(`/criterion/${element.id}/parent_approved/`, {
        value: element.value,
        time_day,
        date,
      });
    }
    childId && dispatch('fetchChildCriterionValues', { childId, date });
    return true;
  } catch (error) {
    commit('error', error);
    return false;
  }
}

export async function setChildCheckValues({ commit }, data) {
  let returnValue = true;
  for (let index = 0; index < data.items.length; index++) {
    let element = data.items[index];
    await Vue.axios({
      method: 'POST',
      url: `/criterion/${element.id}/child_approved/`,
      data: {
        time_day: data.time_day,
        date: data.date,
      },
    })
      .then(() => {
        commit('cleanErrors');
      })
      .catch((error) => {
        commit('error', error);
        returnValue = false;
      });
  }
  return returnValue;
}

export async function FetchChildCriterionToday({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/challenge_values_today/`,
  })
    .then(async function(response) {
      await Vue.axios({
        method: 'GET',
        url: `/child/${childId}/challenges_order/`,
      }).then((orderResponse) => {
        commit('setCriterionToday', {
          data: response.data,
          order: orderResponse.data,
        });
      });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function fetchCriterionCategories({ commit }) {
  try {
    commit('cleanErrors');
    const { data } = await axios.get('/criterion/category/');
    commit('setCriterionCategories', data);
  } catch (error) {
    commit('error', error);
    throw new Error('Error when trying fetch the criterion categories...');
  }
}

export async function fetchCriterionImages({ commit }, idParent) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/criterion/${idParent}/image/`,
  })
    .then((response) => {
      commit('setCriterionImages', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function fetchCriterionTimeFrequencyChoices({ commit }) {
  try {
    commit('cleanErrors');
    const { data } = await axios.get('/criterion/timeday_frequency_choices/');
    commit('setCriterionTimeFrequencyChoices', data);
  } catch (error) {
    commit('error', error);
    throw new Error('Error when obtaining the frequency of days');
  }
}

export async function fetchCriterionTimeDayChoices({ commit }) {
  try {
    commit('cleanErrors');
    const { data } = await axios.get('/criterion/timeday_choices/');
    commit('setCriterionTimeDayChoices', data);
  } catch (error) {
    commit('error', error);
    throw new Error('[Error]: Problems to triying fetch the criterion time day choices');
  }
}

export async function fetchCriterionDaysOfWeek({ commit }) {
  try {
    commit('cleanErrors');
    const { data } = await axios.get('/criterion/timeday_day_choices/');
    commit('setCriterionDaysOfWeek', data);
  } catch (error) {
    commit('error', error);
    throw new Error('Error when obtaining the frequency of days of week');
  }
}

export async function fetchPredefinedCriterion({ commit }) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/criterion/predefined/`,
  })
    .then((response) => {
      commit('setPredefinedCriterion', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function addChallengeImage({ commit }, { data, idParent }) {
  commit('cleanErrors');
  try {
    const response = await Vue.axios({
      method: 'POST',
      url: `/criterion/${idParent}/add_image/`,
      data: {
        image: data.base64,
        name: data.file.name.slice(0, data.file.name.lastIndexOf('.')),
      },
    });
    commit('addCriterionImage', response.data);
  } catch (error) {
    commit('error', {
      ...error,
      message: "The image wasn't succesfully uploaded. Try again",
    });

    throw error;
  }
}
